export default 'notifications';
